<template>
  <div>
    <div class="card">
      <div class="card-header">
        <i class="fa fa-align-justify"></i>
        Faktury
      </div>
      <div class="card-actions">
        <a href class="btn btn-secondary btn-sm" @click.prevent="toggleFiltersVisibility()">
          <span v-if="filtersVisible">Ukryj filtry</span>
          <span v-if="!filtersVisible">Pokaż filtry</span>
        </a>
      </div>
      <div class="card-filters" v-if="filtersVisible">
        <form @submit.prevent="searchList()">
          <div class="row">
            <div class="form-group col-md-2">
              <label for="qInvoiceNumber">Numer FV</label>
              <input class="form-control" v-model="filters.qInvoiceNumber" id="qInvoiceNumber" type="text"/>
            </div>
            <div class="form-group col-md-2">
              <label for="qTaxId">NIP</label>
              <input class="form-control" v-model="filters.qTaxId" id="qTaxId" type="text"/>
            </div>
            <div class="form-group col-md-2">
              <label for="qCompanyName">Nazwa</label>
              <input class="form-control" v-model="filters.qCompanyName" id="qCompanyName" type="text"/>
            </div>

          </div>
          <div class="row">
            <div class="form-group col-12">
              <button type="submit" class="btn btn-primary">Szukaj</button>

              <button type="button" @click="clearFilters()" class="btn btn-link">Wyczyść filtry</button>
            </div>
          </div>
        </form>
      </div>
      <div class="card-body">
        <table class="table table-responsive-sm table-bordered table-striped">
          <thead class="">
          <tr>
            <th scope="col">Obiekt</th>
            <th scope="col">Rodzaj</th>
            <th scope="col">Numer</th>
            <th scope="col">Data</th>
            <th scope="col">NIP</th>
            <th scope="col">Nazwa firmy</th>
            <th scope="col">Klient</th>
            <th scope="col">Netto</th>
            <th scope="col">VAT</th>
            <th scope="col">Brutto</th>
          </tr>
          </thead>
          <tbody>
          <tr class="loading" v-if="isLoading" v-bind:key="item"
              v-for="item in $store.state[paramsName].pageSize">
            <td v-bind:data-id="item"></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
          </tr>
          <tr v-if="!totalCount && !isLoading">
            <td colspan="10">
              Brak rekordów spełniających podane kryteria.
              Zmień lub <a href @click.prevent="clearFilters()">wyczyść filtry</a>.
            </td>
          </tr>
          <tr v-for="invoice in invoices" v-if="!isLoading" :key="invoice.id" class="client-row">
            <td>{{ invoice.branchName }}</td>
            <td>{{ $t('invoices.invoiceTypes.' + invoice.documentType ) }}</td>
            <td>{{ invoice.invoiceNumber }}</td>
            <td>{{ invoice.invoiceDate | date }}</td>
            <td>{{ invoice.taxId }}</td>
            <td>{{ invoice.companyName}}</td>
            <td>
              <span v-if="invoice.clientId">
                {{ invoice.clientName }} ({{ invoice.clientId }}) <a href
                                                                     @click.prevent="goToClientDetails(invoice.clientId)">Zobacz</a>
              </span>
            </td>
            <td>{{ invoice.totalNet | currency }}</td>
            <td>{{ invoice.totalTax | currency }}</td>
            <td>{{ invoice.totalGross | currency }}</td>
          </tr>
          </tbody>
        </table>
      </div>
      <list-pager
          v-bind:params-name="paramsName"
          v-bind:total-count="totalCount"
          @reload="loadItems()">
      </list-pager>
    </div>
  </div>

</template>

<script>
  import invoicesService from '@Service/invoicesService';
  import { toastError, listMixin } from '../helpers';
  import { router } from '@Router';
  import listPager from '@Component/list-pager';

  export default {
    data: function () {
      return {
        paramsName: 'invoicesParams',
        invoices: [],
        totalCount: 0,
        logDetails: null,
        filters: {},
        filtersVisible: false,
        isLoading: false,
      };
    },
    mixins: [
      listMixin,
    ],
    components: {
      listPager,
    },
    methods: {
      loadItems: function () {
        this.isLoading = true;
        invoicesService.getInvoicesList(this.$store.state[this.paramsName])
          .then(response => {
            this.totalCount = parseInt(response.headers.get('totalCount'), 10);
            this.invoices = response.data;
          })
          .catch(toastError)
          .then(() => this.isLoading = false);
      },
      goToClientDetails: (clientId) => {
        router.push({ name: 'clientDetails', params: { clientId } });
      },
      searchList: function () {
        this.$store.commit('setParams', {
          paramsName: 'invoicesParams',
          params: {
            ...this.filters,
            offset: 0,
          },
        });
        this.loadItems();
      },
      clearFilters: function () {
        this.filters = {
          qInvoiceNumber: '',
          qTaxId: '',
          qCompanyName: '',
        };
        this.searchList();
      },
    },
    mounted: function () {
      this.filters = {
        qInvoiceNumber: this.$store.state[this.paramsName].qInvoiceNumber,
        qTaxId: this.$store.state[this.paramsName].qTaxId,
        qCompanyName: this.$store.state[this.paramsName].qCompanyName,
      };
      this.filtersVisible = this.$store.state[this.paramsName].filtersVisible;
      this.loadItems();
    },
  };
</script>
<style>

</style>